import useApiService from "./ApiService";
import CONFIG from "./CONFIG";

export function useTrainApiProvider() {
    const { get, put } = useApiService(CONFIG.SERVER_ASSISTANT);
    const { get_channel } = useApiService(CONFIG.SERVER_CHANNEL);

    const getMetadata = async (messageId) => {
        const response = await get_channel(`/v1/conversations/all/any/messages/${messageId}/metadata`);
        return response.data;
    }

    const updateInstruction = async (frameId, instruction) => {
        const response = await get(`/v1/assistant_frames/${frameId}`);
        
        const data = {
            name: response.data.name,
            frame_type: response.data.frame_type,
            topic: response.data.topic,
            criteria: response.data.criteria,
            example: response.data.example,
            is_active: response.data.is_active,
            instruction: instruction
        }

        await put(`/v1/assistant_frames/${frameId}`, data);
    }

    return {
        getMetadata,
        updateInstruction
    }
}